module.exports = __webpack_public_path__ + "static/media/standard_image.95e9f322.png";